import './Stepper.less'
import { Stepper } from './Stepper'

export type { StepperProps, StepperRef } from './iStepper'

export default Stepper
